import { createAction } from "@ngrx/store";

export const startEffects = createAction("[Room/LiveView] Start Effects");
export const stopEffects = createAction("[Room/LiveView] Stop Effects");

export const init = createAction("[Room/LiveView] Init");
export const destroy = createAction("[Room/LiveView] Destroy");
